const rutasMaestroDetalle = [
  { path: 'anatomia_anataten/:p_idanatomia', name: 'Anatomia_AnatAten', component: 'Anatomia_AnatAten' },
  { path: 'antecedente_anteaten/:p_idantecedente', name: 'Antecedente_AnteAten', component: 'Antecedente_AnteAten' },
  { path: 'asiento_asientodet/:p_idasiento', name: 'Asiento_AsientoDet', component: 'Asiento_AsientoDet' },
  { path: 'atencion_diagaten/:p_idatencion', name: 'Atencion_DiagAten', component: 'Atencion_DiagAten' },
  { path: 'atencion_anteaten/:p_idatencion', name: 'Atencion_AnteAten', component: 'Atencion_AnteAten' },
  { path: 'atencion_tratamiento/:p_idatencion', name: 'Atencion_Tratamiento', component: 'Atencion_Tratamiento' },
  { path: 'atencion_examaten/:p_idatencion', name: 'Atencion_ExamAten', component: 'Atencion_ExamAten' },
  { path: 'atencion_biomaten/:p_idatencion', name: 'Atencion_BiomAten', component: 'Atencion_BiomAten' },
  {
    path: 'atencion_atenciondet',
    name: 'Atencion_AtencionDet',
    component: 'Atencion_AtencionDet',
    props: () => ({
      p_idAtencion: Number(window.history.state?.idAtencion),
    })
  },
  { path: 'atencion_anataten/:p_idatencion', name: 'Atencion_AnatAten', component: 'Atencion_AnatAten' },
  { path: 'biometria_biomaten/:p_idbiometria', name: 'Biometria_BiomAten', component: 'Biometria_BiomAten' },
  { path: 'cita_atencion/:p_idcita', name: 'Cita_Atencion', component: 'Cita_Atencion' },
  { path: 'cita_especita/:p_idcita', name: 'Cita_EspeCita', component: 'Cita_EspeCita' },
  { path: 'clasdiag_diagnostico/:p_idclasdiag', name: 'ClasDiag_Diagnostico', component: 'ClasDiag_Diagnostico' },
  { path: 'claselem_elemento/:p_idclaselem', name: 'ClasElem_Elemento', component: 'ClasElem_Elemento' },
  { path: 'consejo_consperf/:p_idconsejo', name: 'Consejo_ConsPerf', component: 'Consejo_ConsPerf' },
  { path: 'diagnostico_diagaten/:p_iddiagnostico', name: 'Diagnostico_DiagAten', component: 'Diagnostico_DiagAten' },
  { path: 'diagnostico_plandiag/:p_iddiagnostico', name: 'Diagnostico_PlanDiag', component: 'Diagnostico_PlanDiag' },
  { path: 'elemento_recetadet/:p_idelemento', name: 'Elemento_RecetaDet', component: 'Elemento_RecetaDet' },
  { path: 'elemempr_existencia/:p_idelemempr', name: 'ElemEmpr_Existencia', component: 'ElemEmpr_Existencia' },
  { path: 'empresa_horario/:p_idempresa', name: 'Empresa_Horario', component: 'Empresa_Horario' },
  { path: 'empresa_empresaimg/:p_idempresa', name: 'Empresa_EmpresaImg', component: 'Empresa_EmpresaImg' },
  { path: 'empresa_persona/:p_idempresa', name: 'Empresa_Persona', component: 'Empresa_Persona' },
  { path: 'empresa_cita/:p_idempresa', name: 'Empresa_Cita', component: 'Empresa_Cita' },
  { path: 'empresa_usuario/:p_idempresa', name: 'Empresa_Usuario', component: 'Empresa_Usuario' },
  { path: 'empresa_medioemp/:p_idempresa', name: 'Empresa_MedioEmp', component: 'Empresa_MedioEmp' },
  { path: 'empresa_paremp/:p_idempresa', name: 'Empresa_ParEmp', component: 'Empresa_ParEmp' },
  { path: 'especialidad_medico/:p_idespecialidad', name: 'Especialidad_Medico', component: 'Especialidad_Medico' },
  { path: 'especialidad_especita/:p_idespecialidad', name: 'Especialidad_EspeCita', component: 'Especialidad_EspeCita' },
  { path: 'estadocivil_persona/:p_idestadocivil', name: 'EstadoCivil_Persona', component: 'EstadoCivil_Persona' },
  { path: 'examenfisico_examaten/:p_idexamenfisico', name: 'ExamenFisico_ExamAten', component: 'ExamenFisico_ExamAten' },
  { path: 'factura_facturadet/:p_idfactura', name: 'Factura_FacturaDet', component: 'Factura_FacturaDet' },
  { path: 'fechacita_horario/:p_idfechacita', name: 'FechaCita_Horario', component: 'FechaCita_Horario' },
  { path: 'formapago_suscripcion/:p_idformapago', name: 'FormaPago_Suscripcion', component: 'FormaPago_Suscripcion' },
  { path: 'horario_cita/:p_idhorario', name: 'Horario_Cita', component: 'Horario_Cita' },
  { path: 'informeinter_diaginter/:p_idatencion/:p_idinterconsulta', name: 'InformeInter_DiagInter', component: 'InformeInter_DiagInter' },
  { path: 'interconsulta_plandiag/:p_idinterconsulta', name: 'Interconsulta_PlanDiag', component: 'Interconsulta_PlanDiag' },
  { path: 'interconsulta_plantera/:p_idinterconsulta', name: 'Interconsulta_PlanTera', component: 'Interconsulta_PlanTera' },
  { path: 'localidad_empresa/:p_idlocalidad', name: 'Localidad_Empresa', component: 'Localidad_Empresa' },
  { path: 'localidad_persona/:p_idlocalidad', name: 'Localidad_Persona', component: 'Localidad_Persona' },
  { path: 'medico_especita/:p_idmedico', name: 'Medico_EspeCita', component: 'Medico_EspeCita' },
{
  path: 'medico_agenda',
  name: 'Medico_Agenda',
  component: 'Medico_Agenda',
  props: () => ({
    p_idMedico: Number(window.history.state?.idMedico),
  })
},  
  { path: 'medico_atencion/:p_idmedico', name: 'Medico_Atencion', component: 'Medico_Atencion' },
  { path: 'medico_interconsulta/:p_idmedico', name: 'Medico_Interconsulta', component: 'Medico_Interconsulta' },
  { path: 'mediocom_mediopers/:p_idmediocom', name: 'MedioCom_MedioPers', component: 'MedioCom_MedioPers' },
  { path: 'mediocom_mediocomimg/:p_idmediocom', name: 'MedioCom_MedioComImg', component: 'MedioCom_MedioComImg' },
  { path: 'mediocom_medioemp/:p_idmediocom', name: 'MedioCom_MedioEmp', component: 'MedioCom_MedioEmp' },
  { path: 'modulo_moduplan/:p_idmodulo', name: 'Modulo_ModuPlan', component: 'Modulo_ModuPlan' },
  { path: 'modulo_tablmodu/:p_idmodulo', name: 'Modulo_TablModu', component: 'Modulo_TablModu' },
  { path: 'modulo_moduusua/:p_idmodulo', name: 'Modulo_ModuUsua', component: 'Modulo_ModuUsua' },
  { path: 'modulo_rolmodu/:p_idmodulo', name: 'Modulo_RolModu', component: 'Modulo_RolModu' },
  { path: 'moduusua_accesosesion/:p_idmoduusua', name: 'ModuUsua_AccesoSesion', component: 'ModuUsua_AccesoSesion' },
  { path: 'parametro_paremp/:p_idparametro', name: 'Parametro_ParEmp', component: 'Parametro_ParEmp' },
  { path: 'perfil_usuario/:p_idperfil', name: 'Perfil_Usuario', component: 'Perfil_Usuario' },
  { path: 'persona_medico/:p_idpersona', name: 'Persona_Medico', component: 'Persona_Medico' },
  { path: 'persona_atencion/:p_idpersona', name: 'Persona_Atencion', component: 'Persona_Atencion' },
{
  path: 'persona_mediopers',
  name: 'Persona_MedioPers',
  component: 'Persona_MedioPers',
  props: () => ({
    p_idPersona: Number(window.history.state?.idPersona),
  })
},
  { path: 'persona_cita/:p_idpersona', name: 'Persona_Cita', component: 'Persona_Cita' },
  { path: 'plan_suscripcion/:p_idplan', name: 'Plan_Suscripcion', component: 'Plan_Suscripcion' },
  { path: 'plan_moduplan/:p_idplan', name: 'Plan_ModuPlan', component: 'Plan_ModuPlan' },
  { path: 'plancontable_cuenta/:p_idplancontable', name: 'PlanContable_Cuenta', component: 'PlanContable_Cuenta' },
  { path: 'rol_moduusua/:p_idrol', name: 'Rol_ModuUsua', component: 'Rol_ModuUsua' },
  { path: 'rol_rolmodu/:p_idrol', name: 'Rol_RolModu', component: 'Rol_RolModu' },
  { path: 'sesion_accesosesion/:p_idsesion', name: 'Sesion_AccesoSesion', component: 'Sesion_AccesoSesion' },
  { path: 'suscripcion_suscpago/:p_idsuscripcion', name: 'Suscripcion_SuscPago', component: 'Suscripcion_SuscPago' },
  { path: 'tipoelem_claselem/:p_idtipoelem', name: 'TipoElem_ClasElem', component: 'TipoElem_ClasElem' },
  { path: 'tipoexamen_examen/:p_idtipoexamen', name: 'TipoExamen_Examen', component: 'TipoExamen_Examen' },
  { path: 'tipoiden_persona/:p_idtipoiden', name: 'TipoIden_Persona', component: 'TipoIden_Persona' },
  { path: 'tipoiden_empresa/:p_idtipoiden', name: 'TipoIden_Empresa', component: 'TipoIden_Empresa' },
  { path: 'tratamiento_receta/:p_idtratamiento', name: 'Tratamiento_Receta', component: 'Tratamiento_Receta' },
  { path: 'tratamiento_pedido/:p_idtratamiento', name: 'Tratamiento_Pedido', component: 'Tratamiento_Pedido' },
  { path: 'usuario_moduusua/:p_idusuario', name: 'Usuario_ModuUsua', component: 'Usuario_ModuUsua' },
  { path: 'usuario_suscripcion/:p_idusuario', name: 'Usuario_Suscripcion', component: 'Usuario_Suscripcion' },
  { path: 'usuario_sesionerr/:p_idusuario', name: 'Usuario_SesionErr', component: 'Usuario_SesionErr' },
  { path: 'usuario_sesion/:p_idusuario', name: 'Usuario_Sesion', component: 'Usuario_Sesion' },
  { path: 'usuario_cita/:p_idusuario', name: 'Usuario_Cita', component: 'Usuario_Cita' },
  { path: 'plantilla_plantilladet/:p_idplantilla', name: 'Plantilla_PlantillaDet', component: 'Plantilla_PlantillaDet' },
  { path: 'tramite_carga/:p_idtramite', name: 'Tramite_Carga', component: 'Tramite_Carga' },

{
  path: 'pedido_pedidodet',
  name: 'Pedido_PedidoDet',
  component: 'Pedido_PedidoDet',
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_tipo:           window.history.state?.tipo,
    p_numero:         window.history.state?.numero,
  })
},
{
  path: 'receta_recetadet',
  name: 'Receta_RecetaDet',
  component: 'Receta_RecetaDet',
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_numero:         window.history.state?.numero,
  })
},
{
  path: 'pedido_archivo',
  name: 'Pedido_Archivo',
  component: 'Pedido_Archivo',
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_tipo:           window.history.state?.tipo,
    p_numero:         window.history.state?.numero,
    p_idPedido:       Number(window.history.state?.idPedido),
  })
},
{
  path: 'atencion-interconsulta',
  name: 'Atencion_Interconsulta',
  component: 'Atencion_Interconsulta',
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_numero:         window.history.state?.numero,
  })
},
{
  path: 'atencion-referencia',
  name: 'Atencion_Referencia',
  component: 'Atencion_Referencia',
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_numero:         window.history.state?.numero,
  })
},
{
  path: 'persona-alergiapers',
  name: 'Persona_AlergiaPers',
  component: 'Persona_AlergiaPers',
  props: () => ({
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_numero:         window.history.state?.numero,
    p_idPersona:      Number(window.history.state?.idPersona),
  })
},
{
  path: 'persona-vacunapers',
  name: 'Persona_VacunaPers',
  component: 'Persona_VacunaPers',
  props: () => ({
    p_pagina:         window.history.state?.pagina,
    p_idAtencion:     Number(window.history.state?.idAtencion),
    p_estadoAtencion: window.history.state?.estadoAtencion,
    p_numero:         window.history.state?.numero,
    p_idPersona:      Number(window.history.state?.idPersona),
    p_edad:           Number(window.history.state?.edad),
  })
},
]

// Genera las rutas con lazy load, respetando props personalizado si existe
const rutas = rutasMaestroDetalle.map(({ path, name, component, props }) => ({
  path: `/${path}`,
  name,
  component: () => import(`../views/masterDetails/${component}.vue`),
  props: props ?? true
}))

export default rutas